function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    const handleChange = this.onChange.bind(this);

    this.input.addEventListener('input', handleChange, { passive: true });
    this.input.addEventListener('change', handleChange, { passive: true });

    handleChange();

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  onChange(evt) {
    let nextValue = Number(this.input.value);

    if (isNaN(nextValue)) {
      nextValue = 1;
    }

    let min = Number(this.input.min || -Infinity);

    if (isNaN(min)) {
      min = -Infinity;
    }

    let max = Number(this.input.max || Infinity);

    if (isNaN(max)) {
      max = Infinity;
    }

    const minValue = Math.min(min, max);
    const maxValue = Math.max(min, max);

    this.querySelector('button[name="minus"]')?.[nextValue <= minValue ? 'setAttribute' : 'removeAttribute'](
      'disabled',
      '',
    );
    this.querySelector('button[name="plus"]')?.[nextValue >= maxValue ? 'setAttribute' : 'removeAttribute'](
      'disabled',
      '',
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.searchbar = this.querySelector('.predictive-search-input-wrapper input');
    this.closeDrawer = this.querySelector('#close-search-drawer');

    if (this.closeDrawer) {
      this.closeDrawer.addEventListener('click', this.closeMenuDrawer.bind(this));
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );

    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');

      if (this.searchbar) {
        this.searchbar.focus();
      }
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.js-template-popup');
    const playVideo = () => {
      const video = this.querySelector('video');
      if (!video) return;

      video.currentTime = 0;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    window.pauseAllMedia();
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    playVideo();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class CartDialog extends ModalDialog {
  constructor() {
    super();

    this.openBy = this.getAttribute('openBy');

    if (this.openBy == 'page-load') {
      this.show();
    }
  }
}
customElements.define('cart-dialog', CartDialog);

class ScrapSackDialog extends ModalDialog {
  constructor() {
    super();

    //   this.querySelector('[id^="ReviewCart-"]').addEventListener(
    //     'click',
    //     this.openCartDrawer.bind(this, false),
    //   );
    // }

    // openCartDrawer() {
    //   this.hide();
    //   window.SLIDECART_OPEN();
  }
}

customElements.define('scrap-sack-dialog', ScrapSackDialog);

// console.log('this is one the cart');

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));

      if (deferredElement.tagName === 'VIDEO') {
        deferredElement.muted = false;
      }

      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class AccordionComponent extends HTMLElement {
  constructor() {
    super();
    if (!this.id) return;

    this.querySelectorAll(`[id^="Details-${this.id}"]`).forEach((detail) => {
      detail.addEventListener('click', this.onDetailClick.bind(this));
    });
  }

  onDetailClick(event) {
    const currentDetail = event.currentTarget;

    document.querySelectorAll(`[id^="Details-${this.id}"][open]`).forEach((openedDetail) => {
      if (currentDetail != openedDetail) openedDetail.removeAttribute('open');
    });

    currentDetail.scrollIntoView();
  }
}

customElements.define('accordion-component', AccordionComponent);

class ButtonComponent extends HTMLButtonElement {
  constructor() {
    super();

    this.addEventListener('click', (e) => {
      e.preventDefault();

      if (this.location) {
        location.href = this.getAttribute('location');
      }
    });
  }

  get location() {
    return this.hasAttribute('location');
  }
}

customElements.define('button-component', ButtonComponent, {
  extends: 'button',
});

// Money formatter for variant buttons. global.js loads before jquery.products.min.js,
// which is where Shopify.formatMoney is defined, so it is not there yet when the size
// buttons first set up. Use it when available, otherwise format the price here.
function formatVariantMoney(cents, format) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents, format);
  }
  const value = Number(cents) / 100;
  const withDelims = (precision, thousands, decimal) => {
    const parts = value.toFixed(precision).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  };
  return String(format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
    switch (key) {
      case 'amount_no_decimals': return withDelims(0, ',', '.');
      case 'amount_with_comma_separator': return withDelims(2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return withDelims(0, '.', ',');
      default: return withDelims(2, ',', '.');
    }
  });
}

class VariantInputs extends HTMLElement {
  constructor() {
    super();
    const initialVariantData = this.getVariantData();
    this.hasMultipleVariants = Array.isArray(initialVariantData) && initialVariantData.length > 1;
    this.isInitialSync = false;
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.updateVariantOptionsPrice();
    this.removeVariants();
    this.deactivateOptions();
    this.selectActiveOption();
    this.addEventListener('change', this.updatePriceLabel.bind(this), true);
    this.updatePriceLabel();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    this.dispatchEvent(new CustomEvent('variantChanged', { detail: { variant: this.currentVariant } }));
  }

  updatePriceLabel(e) {
    let select;
    if (e?.target.tagName.toLowerCase() === 'select') {
      select = e.target;
    } else {
      select = this.querySelector('select');
    }
    if (!select) return;
    const selectedSize = select.value;
    const variantData = this.getVariantData();
    const selectedVariant = variantData.find((variant) => variant.title.includes(selectedSize));
    if (selectedVariant) {
      // Get the shop's money format from the hidden input
      const shopMoneyFormat = document.getElementById('hulk_currency_symbol')?.value;
      if (!shopMoneyFormat) {
        console.warn('Shop money format not found. Please ensure the hulk_currency_symbol input is present.');
        return;
      }

      const priceLabels = this.querySelectorAll('[data-price]');
      priceLabels.forEach((label) => {
        label.textContent = formatVariantMoney(selectedVariant.price, shopMoneyFormat);
      });
    }
  }

  selectActiveOption() {
    const enabledInputs = [...this.querySelectorAll('input[type="radio"]:checked, select')];

    if (enabledInputs.length) {
      this.isInitialSync = true;
      try {
        enabledInputs.forEach((input) => {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      } finally {
        this.isInitialSync = false;
      }
    }
  }

  deactivateOptions() {
    const variantData = this.getVariantData();
    const inputElements = this.querySelectorAll('input[type="radio"], select');

    let outOfStockCount = 0;

    for (let i = 0, l = variantData.length; i < l; i++) {
      const isOutOfStock = variantData[i].is_out_of_stock === 'true' || variantData[i].available === false;

      if (!variantData[i].available || isOutOfStock) {
        outOfStockCount++;
        inputElements.forEach((input) => {
          if (input.value === variantData[i].title) {
            input.disabled = true;
          }
        });
      }
    }

    // Only show "Sold out" here when every size is sold out. Otherwise the selected
    // size sets the button (renderProductInfo), so in-stock sizes don't flash "Sold out".
    if (variantData.length && outOfStockCount === variantData.length) {
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }
  }

  removeVariants() {
    const variantData = this.getVariantData();
    const selectElements = this.querySelectorAll('select');
    const removedVariants = variantData.filter(
      (variant) => variant.available === false || variant.is_out_of_stock === 'true',
    );

    if (selectElements.length > 0) {
      for (const select of selectElements) {
        if (removedVariants.length > 0) {
          for (const variant of removedVariants) {
            select.querySelector(`option[value="${variant.title}"]`)?.remove();
          }

          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const inputElements = Array.from(this.querySelectorAll('input[type="radio"]:checked, select'));

    if (fieldsets.length) {
      this.options = inputElements.map((input) => input.value);
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;

    const skipInitialUpdate = this.isInitialSync && !this.hasMultipleVariants;

    if (!skipInitialUpdate) {
      this.updateFeaturedImage();
    }

    if (skipInitialUpdate || !this.currentVariant.featured_media) return;

    const productSlider = document.querySelector(`[id^="Slider-${this.dataset.section}"]`);
    if (!productSlider || !window.KeenSlider || !window.KeenSlider.sliders) return;

    const mediaGalleries = productSlider.querySelectorAll(`[id^="Slide-${this.dataset.section}"]`);
    const currentVariantSlide = productSlider.querySelector(
      `[id^="Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
    );
    if (!currentVariantSlide || !currentVariantSlide.parentElement) return;

    const index = [...currentVariantSlide.parentElement.children].indexOf(currentVariantSlide);
    const sliderInstance = window.KeenSlider.sliders[productSlider.id];
    if (!sliderInstance || typeof sliderInstance.moveToIdx !== 'function') return;

    mediaGalleries.forEach((mediaGallery) => {
      if (mediaGallery.id === currentVariantSlide.id) {
        sliderInstance.moveToIdx(index);
      }
    });
  }

  updateFeaturedImage() {
    const featuredImageEl = document.querySelector('.custom--images__main .featured-product-image');
    if (!featuredImageEl) return;

    const linkEl = featuredImageEl.closest('a');
    const defaultSrc = featuredImageEl.dataset.defaultSrc;
    const defaultAlt = featuredImageEl.dataset.defaultAlt;
    const defaultZoom = featuredImageEl.dataset.defaultZoom;
    const variantImage = this.currentVariant?.featured_image;

    if (variantImage && variantImage.src) {
      const mediumSrc = this.getSizedImageUrl(variantImage.src, 800) || variantImage.src;
      const zoomSrc = this.getSizedImageUrl(variantImage.src, 1200) || variantImage.src;

      featuredImageEl.src = mediumSrc;
      featuredImageEl.alt = variantImage.alt || defaultAlt || '';

      if (linkEl) {
        linkEl.href = zoomSrc;
        if (this.currentVariant?.featured_media?.position) {
          linkEl.dataset.index = String(this.currentVariant.featured_media.position - 1);
        }
      }
    } else {
      if (defaultSrc) {
        featuredImageEl.src = defaultSrc;
      }
      if (defaultAlt) {
        featuredImageEl.alt = defaultAlt;
      }
      if (linkEl) {
        const originalHref = linkEl.dataset.defaultHref || defaultZoom || defaultSrc;
        if (originalHref) {
          linkEl.href = originalHref;
        }
        if (linkEl.dataset.index) {
          delete linkEl.dataset.index;
        }
      }
    }
  }

  getSizedImageUrl(src, size) {
    if (!src || !size) return src;

    if (window?.Shopify?.Image?.getSizedImageUrl) {
      return window.Shopify.Image.getSizedImageUrl(src, `${size}x`);
    }

    const normalizedSrc = src.startsWith('//') ? `https:${src}` : src;
    const [baseUrl, query] = normalizedSrc.split('?');
    const extensionMatch = baseUrl.match(/(\.[^./?]+)$/);
    if (!extensionMatch) return normalizedSrc;

    const baseWithoutExtension = baseUrl.slice(0, -extensionMatch[0].length);
    const cleanedBase = baseWithoutExtension.replace(/_(\d+x\d+|\d+x|\d+w|\d+h)$/, '');
    const sizedUrl = `${cleanedBase}_${size}x${extensionMatch[0]}${query ? `?${query}` : ''}`;
    return sizedUrl;
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantOptionsPrice() {
    const variantData = this.getVariantData();
    // Get the shop's money format from the hidden input
    const shopMoneyFormat = document.getElementById('hulk_currency_symbol')?.value;
    if (!shopMoneyFormat) {
      console.warn('Shop money format not found. Please ensure the hulk_currency_symbol input is present.');
      return;
    }

    for (let i = 0, l = variantData.length; i < l; i++) {
      const selectElements = this.querySelectorAll('select');
      const inputElements = this.querySelectorAll('input[type="radio"]');

      inputElements.forEach((radio) => {
        if (radio.value != variantData[i].title) return;

        let labelElement = this.querySelector(`label[for="${radio.id}"]`);

        if (labelElement) {
          let labelPrice = labelElement.querySelector('[data-price]');
          labelPrice.textContent = formatVariantMoney(variantData[i].price, shopMoneyFormat);
        }
      });

      selectElements.forEach((select) => {
        Array.from(select.options).forEach((option) => {
          if (option.value != variantData[i].title) return;

          option.text = `${option.text} - ${formatVariantMoney(variantData[i].price, shopMoneyFormat)}`;
        });
      });
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm && typeof productForm.handleErrorMessage == 'function') productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        const isOutOfStock = this.currentVariant.is_out_of_stock === true || !this.currentVariant.available;

        this.toggleAddButton(isOutOfStock, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const productNavButton = document.querySelector(`[data-js="product-navigation-add-to-cart"]`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;

      if (productNavButton) {
        productNavButton.setAttribute('disabled', 'disabled');
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;

      if (productNavButton) {
        productNavButton.removeAttribute('disabled');
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    if (this.variantData) return this.variantData;

    const variantData = JSON.parse(this.querySelector('#variant-data').textContent);
    const variantMetaData = JSON.parse(this.querySelector('#variant-metafield-data').textContent);

    this.variantData = variantData.reduce(function (carry, variant) {
      if (variantMetaData[variant.id]) {
        return [...carry, { ...variant, ...variantMetaData[variant.id] }];
      }

      return [...carry, variant];
    }, []);

    // this.variantData ||
    // JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-inputs', VariantInputs);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);